import App from './App.vue';
import { createConnectedVehiclesApp } from '@library/AppConfiguration/LibraryOptions';
import { AppOptions } from '@library/AppConfiguration/AppOptions';
import { useSessionState } from '@library/Security';
import { useJupiterRouteHandler, useJupiterProps, JupiterRouteGuard } from '@modules/Jupiter';
import { useGoogleAnalytics } from "@app/Components/Google";
import { useGlobalComponents } from './global.components';

import { Api } from "@domain/Security";

import '@vuepic/vue-datepicker/dist/main.css'; 
import '@/assets/styles/tailwind/index.css';
import './assets/styles/app-styles.scss';

// Routes and navigation
import { routes, navigation } from "./routes";
import { useBreadcrumbsInstaller } from '@services/Breadcrumbs';

// Paths
const paths = {
    login: 'api/authentication/login',
    refreshToken: 'api/authentication/refresh-token'
};

// Configure App Options
const api = new Api();
const configuration = new AppOptions( routes, navigation, api, new JupiterRouteGuard(), paths );
configuration.setStyle( "theme-default", false );

// Create App and provide any other configurations
const app = createConnectedVehiclesApp( App, configuration );
app.use( useSessionState() );
app.use( useJupiterRouteHandler() ); // watches route changes for updates to the webview data passed from the App
app.use( useGoogleAnalytics() ); // enables Google Tag Manager tags to track events with metadata
app.use( useGlobalComponents() );
app.use( useBreadcrumbsInstaller() );

// Initialise the jupiter props before mounting the app
const jupiterProps = useJupiterProps();
jupiterProps.initialise();
jupiterProps.isReady().then( () =>
{
    app.mount( '#app' );
});

